import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";

export default {
    methods: {
        async getWarrantyTypeList(filter) {
            var meta = { clientApiMethod: 'getWarrantyTypeList', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "warrantytype", { params: filter, meta: meta })
            return response?.data;
        },
        async getWarrantyType(id) {
            var meta = { clientApiMethod: 'getWarrantyType', input: { id: id } }
            var response = await client().get(store.state.apiRouteRoot + "WarrantyType/" + id, { meta: meta })
            return response?.data;
        },
        async createWarrantyType(newWarrantyType) {
            var meta = {
                clientApiMethod: 'createWarrantyType',
                input: { newWarrantyType },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.warranty_type.warranty_type") })
            }
            var response = await client().post(store.state.apiRouteRoot + 'WarrantyType', newWarrantyType, { meta: meta })
            return response?.data;
        },
        async changeWarrantyType(updatedWarrantyType) {
            var meta = {
                clientApiMethod: 'changeWarrantyType',
                input: { updatedWarrantyType },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.warranty_type.warranty_type") })
            }
            var response = await client().patch(store.state.apiRouteRoot + 'WarrantyType', updatedWarrantyType, { meta: meta })
            return response?.data;
        },
        async deleteWarrantyType(WarrantyTypeId) {
            var meta = {
                clientApiMethod: 'deleteWarrantyType',
                input: { WarrantyTypeId: WarrantyTypeId },
                successText: i18n.t("servicesystem.responses.removed_object", { okey: i18n.t("servicesystem.common_objects.warranty_type.warranty_type") })
            }
            var response = await client().delete(store.state.apiRouteRoot + "WarrantyType/" + WarrantyTypeId, { meta: meta })
            return response?.data;
        },
    }
}